import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(isBetween);

@Component({
  selector: 'app-date-range-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxDaterangepickerMd],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss'
})
export class DateRangePickerComponent implements OnInit {
  @Input() placeholder: string = 'Selecione um período';
  @Input() initialRange: { startDate: Date; endDate: Date } | null = null;
  @Output() dateRangeChanged = new EventEmitter<{ startDate: Date; endDate: Date }>();

  selected: { startDate: dayjs.Dayjs; endDate: dayjs.Dayjs } = {
    startDate: dayjs().startOf('month'),
    endDate: dayjs().endOf('month')
  };
  
  ranges: any = {
    'Este Mês': [dayjs().startOf('month'), dayjs().endOf('month')],
    'Últimos 2 Meses': [dayjs().subtract(1, 'month').startOf('month'), dayjs().endOf('month')],
    'Últimos 3 Meses': [dayjs().subtract(2, 'month').startOf('month'), dayjs().endOf('month')],
    'Últimos 6 Meses': [dayjs().subtract(5, 'month').startOf('month'), dayjs().endOf('month')],
    'Último Ano': [dayjs().subtract(11, 'month').startOf('month'), dayjs().endOf('month')]
  };
  
  locale: any = {
    applyLabel: 'Aplicar',
    cancelLabel: 'Cancelar',
    clearLabel: 'Limpar',
    customRangeLabel: 'Intervalo Personalizado',
    format: 'DD/MM/YYYY',
    monthNames: [
      'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
      'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
    ],
    daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    firstDay: 1
  };

  ngOnInit() {
    if (this.initialRange) {
      this.selected = {
        startDate: dayjs(this.initialRange.startDate),
        endDate: dayjs(this.initialRange.endDate)
      };
    }
  }

  onDatesUpdated(event: any) {
    if(event && event.startDate && event.endDate) {
      const timezoneOffsetHours = (new Date().getTimezoneOffset() / 60);
      const startDate = event.startDate
        .add(3, 'hour')
        .toDate();
      
      const endDate = event.endDate
        .add(timezoneOffsetHours, 'hour')
        .toDate();
      
      this.dateRangeChanged.emit({
        startDate,
        endDate
      });
    }
  }
}
